import './FormStyles.css';
import useInputString from '../../hooks/useInputString';
import { useEffect, useState } from 'react';
import ClassicButton from '../UI/ClassicButton/ClassicButton';
import FromAlert from './FromAlert';
import useUser from '../../hooks/useUser';
import { IUserUpdate } from '../../interfaces/responses/IUserUpdate';
import { updateUser } from '../../http/userAPI';
import useScreenWidth from "../../hooks/useScreenWidth";

const UpdateProfileForm: React.FC = () => {
    const user = useUser();
    const [isLoading, setLoading] = useState<boolean>(false)
    const firstname = useInputString('');
    const middlename = useInputString('');
    const lastname = useInputString('');
    const phone = useInputString('');
    const [alertMessage, setAlertMessage] = useState<string>();
    const [isAlertVisible, setAlertVisible] = useState<boolean>();
    const [errorFields, setErrorFields] = useState<string[]>([]);
    const screenWidth = useScreenWidth();
    
    useEffect(() => {
        if (user) {
            firstname.setValue(user.user?.firstname ?? '');
            middlename.setValue(user.user?.middlename ?? '');
            lastname.setValue(user.user?.lastname ?? '');
            phone.setValue(user.user?.phone ?? '');
        }
    }, [user]);
    
    const closeAlert = () => {
        setAlertVisible(false);
    };
    
    const handleReg = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        
        const missingFields: string[] = [];
        if (!firstname.value) missingFields.push('firstname');
        if (!lastname.value) missingFields.push('lastname');
        if (!phone.value) missingFields.push('phone');
        
        if (missingFields.length > 0) {
            setAlertMessage('Заполните все обязательные поля.');
            setAlertVisible(true);
            setErrorFields(missingFields);
            setLoading(false);
            return;
        }
        
        const userData: IUserUpdate = {
            phone: phone.value,
            firstname: firstname.value,
            lastname: lastname.value,
            middlename: middlename.value || null
        };
        
        if (user.user?.userId) {
            const userId = user.user?.userId;
            
            updateUser(userId, userData)
            .then((response) => {
                if ('error' in response) { 
                    setAlertMessage(response.error); 
                    setAlertVisible(true);
                } else {
                    setAlertMessage('Профиль отредактирован.');
                    setAlertVisible(true);
                }
            })
            .catch(() => {
                setAlertMessage('Произошла ошибка при редактировании профиля. Попробуйте позже.');
                setAlertVisible(true);
            })
            .finally(() => {
                setLoading(false);
                setErrorFields([]);
            });
        }
    };
    
    return (
        <div className='form_container update'>
            <h2>Редактирование</h2>
            <form className="form">
                {isAlertVisible && (
                    <FromAlert onClose={closeAlert}>
                        {alertMessage}
                    </FromAlert>
                )}
                
                <div className={`form_inputContainer`}>
                    <p>Имя</p>
                    <input
                        className={`firstname ${errorFields.includes('firstname') ? 'error' : ''}`}
                        type="text"
                        value={firstname.value}
                        onChange={firstname.onChange}
                        autoCapitalize='name'
                    />
                </div>
                
                <div className={`form_inputContainer`}>
                    <p>Фамилия</p>
                    <input
                        className={`lastname ${errorFields.includes('lastname') ? 'error' : ''}`}
                        type="text"
                        value={lastname.value}
                        onChange={lastname.onChange}
                        autoCapitalize='surname'
                    />
                </div>
                
                <div className='form_inputContainer'>
                    <p>Отчество (при наличии)</p>
                    <input
                        className="midlname"
                        type="text"
                        value={middlename.value}
                        onChange={middlename.onChange}
                        autoCapitalize='midlname'
                    />
                </div>
                
                <div className={`form_inputContainer`}>
                    <p>Номер телефона</p>
                    <input
                        className={`email ${errorFields.includes('phone') ? 'error' : ''}`}
                        type="tel"
                        value={phone.value}
                        onChange={phone.onChange}
                        autoCapitalize='phone'
                    />
                </div>
                
                <ClassicButton isLoading={isLoading} onClick={handleReg} width={screenWidth > 1000 ? '60%' : '100%'} height='40px' innerLoaderSize='20px'>
                    Редактировать
                </ClassicButton>
            </form>
        </div>
    );
}

export default UpdateProfileForm;